import { transformDate } from "../../../../helpers";

export const startEndDate = (startDate: Date, endDate?: Date): string =>
  `Start date: ${transformDate(startDate.toString(), false)} ${
    endDate !== undefined
      ? `/ End date: ${transformDate(endDate.toString(), false)}`
      : ""
  }`;
